import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  public version: string;
  public user: string;

  constructor(
    private rest: RestService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.version = environment.version;
    this.rest.username$.subscribe((username) => {
      this.user = username;
    });
  }

  logout(): void {
    this.auth.logoutNew();
  }

  routeToHome() {
    this.router.navigate(['']);
  }
}
